NodeList.prototype.forEach = Array.prototype.forEach
if (location.hash === "") {
	location.hash = "#home"
}
require('../js-deps/routie.js')
window.jQuery = window.$ = require('../js-deps/jquery.min.js')
require('../js-deps/jquery.magnific-popup.min.js')
require('../js-deps/bootstrap.js')
require('../js-deps/jquery.imagesloaded.min.js')
require('../js-deps/plugins-scroll.js')
$(document).ready(function($) {
	"use strict";
	var winDow = $(window)

	// preloader function
	winDow.load(function () {
		var mainDiv = $('#container'),
			preloader = $('.preloader')

		preloader.fadeOut(400, function () {
			mainDiv.delay(400).addClass('active')
		})
	})

	// Adds window smooth scroll on chrome.
	try {
		$.browserSelector()
		if($('html').hasClass('chrome')) {
			$.smoothScroll()
		}
	}
	catch (err) {}

	// video background
	try {
		jQuery('.player').mb_YTPlayer()
	}
	catch (err) {}

	// ANIMATED CONTENT
	try {
		if ($('.animated')[0]) {
			$('.animated').css('opacity', '0');
		}
	}
	catch (err) {}

	// remove animation in mobile device
	if (winDow.width() < 992) {
		$('div.triggerAnimation').removeClass('animated')
		$('div.triggerAnimation').removeClass('triggerAnimation')
	}

	// alerts fade out
	$('a.close-box').on('click', function (e) {
		e.preventDefault()
		var $this = $(this)

		$this.parent('div').fadeOut()
	})

	try {
		var SliderPost = $('.flexslider')

		SliderPost.flexslider({
			slideshowSpeed: 3000,
			easing: 'swing'
		})
	} catch(err) {

	}

	// Contact Map
	// var contact = {"lat":"-33.880641", "lon":"151.204298"}; //Change a map coordinate here!

	// try {
	// 	var mapContainer = $('.map');
	// 	mapContainer.gmap3({
	// 		action: 'addMarker',
	// 		marker:{
	// 			options:{
	// 				icon : new google.maps.MarkerImage('images/marker.png')
	// 			}
	// 		},
	// 		latLng: [contact.lat, contact.lon],
	// 		map:{
	// 			center: [contact.lat, contact.lon],
	// 			zoom: 16
	// 			},
	// 		},
	// 		{action: 'setOptions', args:[{scrollwheel:false}]}
	// 	);
	// } catch(err) {

	// }

	// magnific-popup
	try {
		var magnLink = $('.login-popup')
		magnLink.magnificPopup({
			closeBtnInside:false
		})
	}
	catch (err) {}

	// Bootstrap tabs
	var tabId = $('.nav-tabs a');
	try {
		tabId.click(function (e) {
			e.preventDefault();
			$(this).tab('show');
		});
	}
	catch (err) {}

	// slider Testimonial
	var slidertestimonial = $('.bxslider');
	try {
		slidertestimonial.bxSlider({
			mode: 'vertical'
		});
	}
	catch (err) {}

	// Accordion & Togles
	var clickElem = $('a.accord-link');
	clickElem.on('click', function(e){
		e.preventDefault();

		var $this = $(this),
			parentCheck = $this.parents('.accord-elem'),
			accordItems = $('.accord-elem'),
			accordContent = $('.accord-content');

		if( !parentCheck.hasClass('active')) {

			accordContent.slideUp(400, function(){
				accordItems.removeClass('active');
			});
			parentCheck.find('.accord-content').slideDown(400, function(){
				parentCheck.addClass('active');
			});

		} else {

			accordContent.slideUp(400, function(){
				accordItems.removeClass('active');
			});

		}
	});

	var TogElem = $('a.toogle-link');

	TogElem.on('click', function(e){
		e.preventDefault();

		var $this = $(this),
			parentCheck = $this.parents('.toogle-elem');

		if( !parentCheck.hasClass('active')) {
			parentCheck.find('.toogle-content').slideDown(400, function(){
				parentCheck.addClass('active');
			});
		} else {
			parentCheck.find('.toogle-content').slideUp(400, function(){
				parentCheck.removeClass('active');
			});

		}
	});

	// Contact Form
	var submitContact = $('#submit_contact'),
		message = $('#msg');

	submitContact.on('click', function(e){
		e.preventDefault();

		var $this = $(this);

		$.ajax({
			type: "POST",
			url: 'contact.php',
			dataType: 'json',
			cache: false,
			data: $('#contact-form').serialize(),
			success: function(data) {

				if(data.info !== 'error'){
					$this.parents('form').find('input[type=text],textarea,select').filter(':visible').val('');
					message.hide().removeClass('success').removeClass('error').addClass('success').html(data.msg).fadeIn('slow').delay(5000).fadeOut('slow');
				} else {
					message.hide().removeClass('success').removeClass('error').addClass('error').html(data.msg).fadeIn('slow').delay(5000).fadeOut('slow');
				}
			}
		});
	});


	// Header animate after scroll
	// (function() {
	// 	var docElem = document.documentElement,
	// 		didScroll = false,
	// 		changeHeaderOn = 40;
	// 		document.querySelector( 'header' );
	// 	function init() {
	// 		window.addEventListener( 'scroll', function() {
	// 			if( !didScroll ) {
	// 				didScroll = true;
	// 				setTimeout( scrollPage, 100 );
	// 			}
	// 		}, false );
	// 	}
	// 	function scrollPage() {
	// 		var sy = scrollY();
	// 		if ( sy >= changeHeaderOn ) {
	// 			$( 'header' ).addClass('active');
	// 		}
	// 		else {
	// 			$( 'header' ).removeClass('active');
	// 		}
	// 		didScroll = false;
	// 	}
	// 	function scrollY() {
	// 		return window.pageYOffset || docElem.scrollTop;
	// 	}
	// 	init();
	// })();

	require('./router.js')
	require('./series.js')
	require('./stars.js')
	require('./bs-nav.js')
	require('./contact.js')
	require('./feedback.js')
	require('./login.js')
});
